// exclude-from-index
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ThemeProvider, StyledEngineProvider, createTheme, adaptV4Theme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { colors } from '../../css';
import { muiGlobalTheme } from '../FormElements.theme';
import { VisibleIcon } from './TextInput.styles';

const StyledTextField = styled(TextField)`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

class TextInput extends PureComponent {
  static propTypes = {
    /**
     * Message that is displayed when the input has an error
     */
    errorText: PropTypes.string,
    /**
     * Optional helper text that sits below the input
     */
    helperText: PropTypes.string,
    variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
  };

  static defaultProps = {
    errorText: 'Error',
    helperText: undefined,
    variant: 'standard'
  };

  constructor(props) {
    super(props);
    // eslint-disable-next-line
    this.muiTheme = muiGlobalTheme;
    muiGlobalTheme.palette.text.primary = colors.colorBlack;
    muiGlobalTheme.palette.text.secondary = colors.colorGrey03;
    muiGlobalTheme.overrides.MuiIconButton = { root: { marginBottom: 10 } };
    this.inputTheme = createTheme(adaptV4Theme(muiGlobalTheme));
    this.state = { showPassword: false };
  }

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }));
  };

  render() {
    const { errorText, helperText, type, ...defaultProps } = this.props;
    const { error, onFocus, InputProps, value } = defaultProps;
    const { showPassword } = this.state;
    const passwordToggle = showPassword ? 'text' : 'password';

    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={this.inputTheme}>
          <StyledTextField
            {...defaultProps}
            type={type === 'password' ? passwordToggle : type}
            fullWidth
            helperText={error ? errorText : helperText}
            onFocus={e => {
              `${value}`.length > 0 && e.target.select();
              if (onFocus) onFocus(e);
            }}
            InputProps={{
              endAdornment: type === 'password' && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={this.handleClickShowPassword}
                    size="large"
                  >
                    <VisibleIcon className={`show-${showPassword}`} />
                  </IconButton>
                </InputAdornment>
              ),
              ...InputProps
            }}
          />
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }
}

export default TextInput;
